import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginForm } from '../../models/login.model';

@Component({
  selector: 'spaq-login-email',
  templateUrl: './login-email.component.html',
  styleUrls: ['./login-email.component.scss'],
})
export class LoginEmailComponent implements OnInit {
  form: FormGroup;
  @Output() onSubmit = new EventEmitter();
  @Input() pending;
  @Input() error;

  constructor(private fb: FormBuilder) {
    this.initForm();
  }

  @Input()
  set formData(data: LoginForm) {
    if (data) {
      this.form.setValue(data);
    }
  }


  submit() {

    Object.keys(this.form.value).forEach(val => {
      this.form.controls[val].markAsDirty();
      this.form.controls[val].markAsTouched();
      this.form.controls[val].updateValueAndValidity();
    });

    if (this.form.valid) {
      this.onSubmit.emit(this.form.value);
    } else {

    }
  }

  initForm() {
    this.form = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
        ],
      ],
      password: [
        '',
        Validators.required,
      ],
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/login/components/login-email/login-email.component.ts